import React from 'react';

const defaultContextValue = {
  ref: null
};

const HelmetContext = React.createContext(defaultContextValue);

export { HelmetContext };
